import {
  Dialog,
  EmptyState,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@all-manager/design-system-v2';
import { ExpenseCategoryDatabase, ExpenseDatabase } from '../../../../types';
import { formatExpenseMonth } from '../../utils/expenseStats';
import { formatAmount } from '../../utils/formatAmount';
import ExpenseMenuAction from '../ExpenseMenuAction/ExpenseMenuAction';

type Props = {
  title: string;
  /** Latest first. */
  expenses: ExpenseDatabase[];
  categories: ExpenseCategoryDatabase[];
  onClose: () => void;
};

export default function ExpenseListDialog(props: Props) {
  return (
    <Dialog
      open
      onClose={props.onClose}
      maxWidth="sm"
      fullWidth
      title={props.title}
      closeLabel="Fermer"
    >
      {props.expenses.length === 0 ? (
        <EmptyState
          title="Aucune dépense"
          subtitle="Les dépenses ajoutées à cette catégorie apparaîtront ici."
        />
      ) : (
        <Table size="small" aria-label={props.title}>
          <TableHead>
            <TableRow>
              <TableCell>Mois</TableCell>
              <TableCell align="right">Montant</TableCell>
              <TableCell padding="checkbox" />
            </TableRow>
          </TableHead>
          <TableBody>
            {props.expenses.map((expense) => (
              <TableRow key={expense.id}>
                <TableCell>{formatExpenseMonth(expense.month)}</TableCell>
                <TableCell align="right">
                  <Typography variant="body1Emphasis">{formatAmount(expense.amount)}</Typography>
                </TableCell>
                <TableCell padding="checkbox">
                  <ExpenseMenuAction expense={expense} categories={props.categories} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Dialog>
  );
}
